import { Button, ButtonVariant } from "@src/components/button/Button";
import { clx } from "@src/components/utils/stringUtils";
import styles from "@src/pages/home/children/pricing/components/map/Map.module.scss";
import React from "react";
import schedulePriceStyles from "./SchedulePrice.module.scss";

interface IAmPm {
	selected?: string;
	onClick: (x: string) => void;
	value1: string;
	value2: string;
}

export const AmPm: React.FC<IAmPm> = ({ selected, onClick, value1, value2 }) => {
	const buttonStyle = {
		width: "28px",
		height: "22px",
		padding: "0px",
		fontSize: "1.1rem",
	};

	const getButtonProps = (value: string) => ({
		style: { ...buttonStyle, opacity: selected === value ? 1 : 0.2 },
		"data-text-white": selected !== value,
		onClick: () => onClick(value),
		variant: selected === value ? ButtonVariant.Primary : ButtonVariant.Secondary,
	});

	return (
		<div className={clx({ [styles.rightContent]: false, [schedulePriceStyles.ampmContainer]: true })}>
			<Button {...getButtonProps(value1)}>AM</Button>
			<Button {...getButtonProps(value2)}>PM</Button>
		</div>
	);
};
